
import { defineComponent } from 'vue'
import LiveWithdraws from '../LiveWithdraws/index.vue'

export default defineComponent({
	components: {
		LiveWithdraws
	}
})
